/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import React from 'react';
const HomePage = React.lazy(() => import('./views/HomePage/HomePage'));
const PDFViewer = React.lazy(() => import('./views/PDFViewer/PDFViewer'));

const routes = [
  { path: '/', exact: true, name: 'Root' },
  {
    name: 'Home',
    path: '/home',
    exact: true,
    component: HomePage,
  },
  {
    name: 'PDF Viewer',
    path: '/pdf-viewer',
    exact: true,
    component: PDFViewer,
  },
];

export default routes;
